var _path;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgress2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8565 24.8564C28.4541 27.2855 26.4377 29.3032 24.0095 30.7073C21.5814 32.1114 18.8268 32.8525 16.0219 32.8563C13.217 32.8602 10.4604 32.1265 8.0284 30.7291C5.59644 29.3316 3.57457 27.3193 2.16553 24.894L5.55647 22.9239C6.62015 24.7548 8.14644 26.2738 9.98232 27.3288C11.8182 28.3837 13.8992 28.9375 16.0165 28.9346C18.1339 28.9318 20.2134 28.3723 22.0464 27.3124C23.8794 26.2524 25.4015 24.7292 26.4602 22.8955L29.8565 24.8564Z",
    fill: "#307FE2"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress2);
export default __webpack_public_path__ + "static/media/progress_2.bcfb19283c70a23a5caf0ecb938f7bd9.svg";
export { ForwardRef as ReactComponent };